<template>
  <div class="w-full">
    <!-- Banner Taller Virtual Desktop -->
    <div class="w-full max-w-6xl mx-auto rounded-2xl overflow-hidden hidden md:flex flex-col md:flex-row items-stretch shadow-lg bg-white relative">
      <!-- Columna de texto -->
      <div class="bg-black text-white flex-1 p-8 flex flex-col justify-center relative z-10">
        <h2
          class="mb-4"
          style="
            font-family: 'Inter', sans-serif;
            font-weight: 700;
            font-size: 28px;
            line-height: 120%;
            letter-spacing: 0%;
            vertical-align: middle;
          "
        >
          {{ bannerData.TITULO }}
        </h2>
        <p
          class="mb-6"
          style="
            font-family: 'Inter', sans-serif;
            font-weight: 400;
            font-size: 14px;
            line-height: 130%;
            letter-spacing: 0%;
          "
        >
          {{ bannerData.SUBTITULO }}
        </p>
        <div class="flex gap-4">
          <a :href="bannerData.URL1" target="_blank" class="bg-[#E38400] text-white font-semibold py-2 px-6 transition-colors" style="border-radius:5px;">{{ bannerData['BOTON 1'] }}</a>
          <a :href="bannerData.URL2" target="_blank" class="border border-white text-white font-semibold py-2 px-6 hover:bg-white hover:text-black transition-colors" style="border-radius:5px;">{{ bannerData['BOTON 2'] }}</a>
        </div>
      </div>
      <!-- Columna de imagen -->
      <div
        class="flex-1 bg-center relative z-5 bg-black"
        :style="`background-image: url('${bannerData.IMAGEN}');`"
      >
        <!-- Puedes dejar este div vacío, o agregar un overlay si lo deseas -->
      </div>
    </div>

    <!-- Banner Taller Virtual Mobile -->
    <div class="block md:hidden">
      <div class="max-w-xl mx-auto rounded-2xl overflow-hidden shadow-lg bg-black">
        <img
          :src="bannerData.IMAGEN"
          alt="Foto del tallerista"
          class="w-full h-48 object-cover"
          style="display:block;"
        />
        <div class="bg-black text-white p-6 flex flex-col items-start">
          <h2
            class="mb-3"
            style="
              font-family: 'Inter', sans-serif;
              font-weight: 700;
              font-size: 22px;
              line-height: 120%;
              letter-spacing: 0%;
              vertical-align: middle;
            "
          >
            {{ bannerData.TITULO }}
          </h2>
          <p
            class="mb-5"
            style="
              font-family: 'Inter', sans-serif;
              font-weight: 400;
              font-size: 13px;
              line-height: 130%;
              letter-spacing: 0%;
            "
          >
            {{ bannerData.SUBTITULO }}
          </p>
          <div class="flex flex-col gap-3 w-full">
            <a :href="bannerData.URL1" target="_blank" class="bg-[#E38400] text-white text-center font-semibold py-2 w-full transition-colors" style="border-radius:5px;">{{ bannerData['BOTON 1'] }}</a>
            <a :href="bannerData.URL2" target="_blank" class="border border-white text-white text-center font-semibold py-2 w-full hover:bg-white hover:text-black transition-colors" style="border-radius:5px;">{{ bannerData['BOTON 2'] }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const bannerData = ref({
  TITULO: 'Taller virtual para mejorar historias',
  SUBTITULO: 'Inscribite al próximo taller de agosto',
  'BOTON 1': 'Inscribirme',
  URL1: 'https://tienda.orsai.org/products/taller-virtual-para-mejorar-historias-de-hernan-casciari-septiembre',
  'BOTON 2': 'Más información',
  URL2: 'https://escuela.orsai.org/inscripciones/1',
  IMAGEN: 'https://hernancasciari.fra1.digitaloceanspaces.com/mascara_banner_thc_f25fc477b7.png'
});

const fetchBannerData = async () => {
  try {
    const response = await fetch('https://docs.google.com/spreadsheets/d/e/2PACX-1vQWBlQ7HDJqR37f4n2_iPk-e887jGyZoXgfVXW3GTmX40Of1PD4tX8E2Lhazio6ToBneoBUz28L0iF_/pub?gid=514914568&single=true&output=csv');
    const csvText = await response.text();
    
    console.log('Raw CSV text:', csvText);
    
    // Parse CSV - manejar el caso donde todo viene en una línea
    const lines = csvText.split('\n').filter(line => line.trim() !== '');
    console.log('Lines filtradas:', lines);
    
    if (lines.length >= 2) {
      const headers = lines[0].split(',');
      const values = lines[1].split(',');
      
      console.log('Headers:', headers);
      console.log('Values:', values);
      
      // Crear JSON mapeando cada columna con su valor
      const jsonData = {};
      headers.forEach((header, index) => {
        jsonData[header.trim()] = values[index]?.trim() || '';
      });
      
      console.log('JSON mapeado:', jsonData);
      
      bannerData.value = jsonData;
    } else {
      console.error('No hay suficientes líneas en el CSV');
    }
  } catch (error) {
    console.error('Error fetching banner data:', error);
    // Keep default values if fetch fails
  }
};

onMounted(() => {
  fetchBannerData();
});
</script> 